import axios from 'axios';
import Common from './Common';
export default { 
    getPrivacy(id) {
        return axios.get(Common.api + 'get-static/' + id);
    },
    sendAffiliatorSearch(data) {
        return axios.post(Common.api + 'get-particular-child', data);
    },
    sendAffliatorProductSearch(data) {
        return axios.post(Common.api + 'get-aff-sales', data);
    },
    saveMessage(data) {
        return axios.post(Common.api + 'store-contact-data', data);
    },
    saveApplication(data) {
        return axios.post(Common.api + 'store-affiliator-application', data);
    }
}